import RestApiClient from '../../core/api/RestApiClient';
import { ICSInvoicesResponse } from './types/ICSInvoicesResponse';
import { CancelToken } from 'axios';

class CaseStatisticsInvoiceAgingApiClient {
    public async GetData(cancelToken: CancelToken): Promise<ICSInvoicesResponse>{
        return await RestApiClient.get<ICSInvoicesResponse>(`modules/CaseStatisticsInvoiceAging/getData`, {}, cancelToken);
    }
}

export default new CaseStatisticsInvoiceAgingApiClient();
